import { render, staticRenderFns } from "./SubscriptionBreakdownModal.vue?vue&type=template&id=706e0e20&"
import script from "./SubscriptionBreakdownModal.vue?vue&type=script&lang=js&"
export * from "./SubscriptionBreakdownModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports